export const editorConfiguration = () => ({
  min_height: 720,
  autoresize: true,
  branding: false,
  statusbar: false,
  language: 'es',
  plugins:
    'powerpaste casechange autolink directionality visualblocks fullscreen image link table hr pagebreak nonbreaking advlist lists textpattern noneditable formatpainter permanentpen quickbars linkchecker emoticons code',
  menubar: 'edit view insert tools table',
  toolbar:
    'undo redo | bold italic underline strikethrough | fontsizeselect fontselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | fullscreen code | emoticons image link ',
  quickbars_insert_toolbar: false,
  image_caption: true,
  automatic_uploads: false,
  file_picker_types: 'media image',
  a11y_advanced_options: true,
  media_poster: false,
  media_alt_source: false,
  content_style: "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;700&display=swap'); body { font-family: Poppins, sans-serif; font-size: 14px; }",
  font_formats: "Poppins=Poppins,sans-serif; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings",
  pagebreak_separator: '<div style="page-break-before: always; clear:both"/></div>',
  pagebreak_split_block: true
})
